import React, { useState, useEffect } from "react";
import { MarkdownRenderer } from "../utils/markdownRenderer";

const TypingAnimation = ({ text }) => {
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      if (index <= text.length) {
        setDisplayText(text.slice(0, index));
        index++;
      } else {
        clearInterval(interval);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [text]);

  return <MarkdownRenderer content={displayText} />;
};

export default TypingAnimation;
